module.exports = __webpack_public_path__ + "static/media/my-account-icon.c3a258e6.svg";